import { combineReducers } from 'redux';

export function error(state = null, action) {
  switch (action.type) {
    case 'INVITATION_DEFAULT_EMAIL_CONTENT_ERROR':
      return action.error;

    case 'INVITATION_DEFAULT_EMAIL_CONTENT_RESET':
      return null;

    default:
      return state;
  }
}

export function loading(state = false, action) {
  switch (action.type) {
    case 'INVITATION_DEFAULT_EMAIL_CONTENT_LOADING':
      return action.loading;

    case 'INVITATION_DEFAULT_EMAIL_CONTENT_RESET':
      return false;

    default:
      return state;
  }
}

export function retrieved(state = null, action) {
  switch (action.type) {
    case 'INVITATION_DEFAULT_EMAIL_CONTENT_SUCCESS':
      return action.retrieved;

    case 'INVITATION_DEFAULT_EMAIL_CONTENT_RESET':
      return null;

    default:
      return state;
  }
}

export default combineReducers({ error, loading, retrieved });
